import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { decodeJWT } from "react-oauth2-code-pkce/dist/decodeJWT";
import { RootState } from "../../store/store";

export type VendorUserType =
{
  sub?: string;
  email?: string;
  token?: string;
  isAuthenticated: boolean;
  isAuthContextConfigured: boolean;
  /** auth is tied to rfiId because we need to get the agency from the RfiId to use for login.gov */
  rfiId?: string;
  isLoading: boolean | null;
  error?: string;
};

const initialState: VendorUserType = {
  sub: "",
  email: "",
  token: undefined,
  isAuthenticated: false,
  isAuthContextConfigured: false,
  rfiId: undefined,
  isLoading: false,
};

export const fetchVendorProfile = createAsyncThunk(
  "asyncVendorUser/fetchVendorProfile",  
  async () => {
    axios.defaults.withCredentials = true;
    const res = await axios.get(`/api/v1/Account/vendorprofile`);
    const data = await res.data;
    return data;
  }
);

export const vendorUserSlice = createSlice({
  name: "vendorUser",
  initialState,
  reducers: {
    setVendorUser: (state: VendorUserType, action: PayloadAction<VendorUserType>) => {
      state.sub = action.payload?.sub;
      state.email = action.payload?.email;
    },
    setToken: (state: VendorUserType, action: PayloadAction<string|undefined>) => {
      if(state.token === action.payload) return;

     

      if(action.payload === null){
        axios.defaults.headers.common["Authorization"] = undefined;
        state.token = undefined;
        state.sub = "";
        state.email = "";
        state.isAuthenticated = false;
        return;
      }
      
      const decode = JSON.parse(atob(action.payload?.split('.')[1]??""));
      if (decode.exp * 1000 < new Date().getTime()) {
        axios.defaults.headers.common["Authorization"] = undefined;
        state.token = undefined;
        state.sub = "";
        state.email = "";
        state.isAuthenticated = false;
        return;
      }

      //axios.defaults.headers.common["Authorization"] = `Bearer ${action.payload}`;
      state.token = action.payload;
      const tokenData = decodeJWT(action.payload?? "");
      state.sub = tokenData.sub;
      state.email = tokenData.email;
      state.isAuthenticated = true;
    },
    setAuthContextConfigured(state: VendorUserType, action: PayloadAction<boolean>){
      state.isAuthContextConfigured = action.payload;
    },
    setRfiId(state: VendorUserType, action: PayloadAction<string|undefined>){
      if (action.payload !== "0"){
        state.rfiId = action.payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVendorProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchVendorProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      axios.defaults.headers.common["Authorization"] = undefined;
      state.token = undefined;
      if(action.payload.email){
        state.sub = action.payload.sub;
        state.email = action.payload.email;
        state.isAuthenticated = true;
      }
     
    });
    builder.addCase(fetchVendorProfile.rejected, (state, action) => {
      state.isLoading = false;
      axios.defaults.headers.common["Authorization"] = undefined;
      state.token = undefined;
      state.sub = "";
      state.email = "";
      state.isAuthenticated = false;
    });

  },

});

export const { setVendorUser, setToken, setAuthContextConfigured, setRfiId } = vendorUserSlice.actions;

export const selectVendorUser = (state: RootState) => state.vendorUser;

export default vendorUserSlice.reducer;